var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 65,
    viewBox: "0 0 62 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 61,
    height: 64,
    rx: 30.5,
    fill: "white",
    fillOpacity: 0.3,
    stroke: "#B7D7F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3673_40923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 15C19.9781 15 18.9375 16.0406 18.9375 17.3125V49.6875C18.9375 50.9594 19.9781 52 21.25 52H44.375C45.6469 52 46.6875 50.9594 46.6875 49.6875V24.25L37.4375 15H21.25Z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.75 24.25H46.6875L37.4375 15V21.9375C37.4375 23.2094 38.4781 24.25 39.75 24.25Z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6875 31.1875L39.75 24.25H46.6875V31.1875Z",
    fill: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0625 45.0625C42.0625 45.6984 41.5422 46.2188 40.9062 46.2188H15.4688C14.8328 46.2188 14.3125 45.6984 14.3125 45.0625V33.5C14.3125 32.8641 14.8328 32.3438 15.4688 32.3438H40.9062C41.5422 32.3438 42.0625 32.8641 42.0625 33.5V45.0625Z",
    fill: "#F15642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3525 36.9074C19.3525 36.6022 19.593 36.2692 19.9804 36.2692H22.116C23.3185 36.2692 24.4007 37.0739 24.4007 38.6164C24.4007 40.0779 23.3185 40.8919 22.116 40.8919H20.5724V42.1129C20.5724 42.5199 20.3134 42.7499 19.9804 42.7499C19.6751 42.7499 19.3525 42.5199 19.3525 42.1129V36.9074ZM20.5724 37.4335V39.7368H22.116C22.7357 39.7368 23.226 39.1899 23.226 38.6164C23.226 37.97 22.7357 37.4335 22.116 37.4335H20.5724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2105 42.7499C25.9053 42.7499 25.5723 42.5834 25.5723 42.1776V36.9259C25.5723 36.5941 25.9053 36.3524 26.2105 36.3524H28.3276C32.5525 36.3524 32.46 42.7499 28.4109 42.7499H26.2105ZM26.7933 37.4809V41.6226H28.3276C30.824 41.6226 30.935 37.4809 28.3276 37.4809H26.7933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9594 37.555V39.0246H36.317C36.65 39.0246 36.983 39.3576 36.983 39.6802C36.983 39.9854 36.65 40.2352 36.317 40.2352H33.9594V42.1765C33.9594 42.5003 33.7293 42.7489 33.4056 42.7489C32.9986 42.7489 32.75 42.5003 32.75 42.1765V36.9248C32.75 36.593 32.9998 36.3513 33.4056 36.3513H36.6512C37.0582 36.3513 37.2987 36.593 37.2987 36.9248C37.2987 37.2208 37.0582 37.5538 36.6512 37.5538H33.9594V37.555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9062 46.2188H18.9375V47.375H40.9062C41.5422 47.375 42.0625 46.8547 42.0625 46.2188V45.0625C42.0625 45.6984 41.5422 46.2188 40.9062 46.2188Z",
    fill: "#CAD1D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3673_40923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(12 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfImg);
export default __webpack_public_path__ + "static/media/pdf-img.600d31e71629a102d82df5758691bdf2.svg";
export { ForwardRef as ReactComponent };